import React from "react";
import { Building2, ShieldCheck } from "lucide-react";

export default function Login() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/cases";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F6F5EF] flex items-center justify-center px-4">
      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <Building2 className="w-7 h-7 text-[#FF4802]" />
          <span className="text-2xl font-semibold tracking-tight text-[#333333]">
            Truva HL <span className="text-[#6B7280] font-normal">· RM Desk</span>
          </span>
        </div>
        <div className="bg-white rounded-2xl border border-[#E2E2E2] p-8 truva-popup-shadow">
          <h1 className="text-xl font-medium text-[#333333]">Sign in</h1>
          <p className="text-sm text-[#6B7280] mt-1 mb-6 leading-relaxed">
            Home Loans RM workspace. Use your <span className="font-medium text-[#333333]">@truva.in</span> Google account.
          </p>
          <button
            onClick={signIn}
            data-testid="google-signin-button"
            className="w-full flex items-center justify-center gap-3 bg-[#FF4802] hover:bg-[#E2521B] text-white font-medium py-3 rounded-lg transition-colors"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5 bg-white rounded" />
            Continue with Google
          </button>
          <div className="flex items-center gap-2 text-xs text-[#6B7280] mt-6">
            <ShieldCheck className="w-4 h-4 text-[#FF4802]" />
            Access is restricted to provisioned Truva Home Loans users.
          </div>
        </div>
      </div>
    </div>
  );
}
